import * as React from 'react';

import { trackEvent } from '../analytics/tracking';
import { navigateTopWithState } from '../routing/router-utils';
import { ReOrderItemsContext } from './ReOrderItemsProvider';
import SimpleCarousel, { CarouselStyle } from '../common/SimpleCarousel';
import { MAX_CAROUSEL_PRODUCTS } from '../home/ProductCarousel';
import Header, { HeaderSize } from '../styleguide/Header';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';

import styles from '../home/ProductCarousel.module.css';
import cardStyles from './ReOrderBrands.module.css';

const ReOrderBrands = () => {

  const { reOrderBrands } = React.useContext(ReOrderItemsContext);

  // Display in-stock previously ordered brands if user has prior orders
  return ( reOrderBrands?.length
    ? <div>
        <div className={styles.sectionHeader}>
          <Header size={HeaderSize.Medium_Static} withStyle={{marginBottom:0}}>
            Your Favorite Brands
            <div className={cardStyles.subHead}>
              Based on recent purchases
            </div>

          </Header>
        </div>
        <SimpleCarousel
          CarouselComponent={BrandCard}
          carouselItemProps={reOrderBrands}
          carouselStyle={CarouselStyle.PRODUCT_CARDS}
          trackingLabel="favorite_brands"
          maxItemCount={MAX_CAROUSEL_PRODUCTS} />
      </div>
    : null
  )
};

const BrandCard = ({display_name, vendor_id}) => {
  const brandClick = React.useCallback(() => {
    trackEvent(`brand_favorites_csl_${vendor_id}_clk`);
    trackEvent(`brand_favorites_csl_clk`);
    navigateTopWithState(
      `/partner/${vendor_id}`,
      {
         returnToPath: window.location.pathname
      }
    )
  }, [vendor_id])

  return (
    <div className={cardStyles.brandCard}  onClick={brandClick}>
      <span data-text-sizing={Math.floor(display_name.length/8)} className={cardStyles.brandLabel}>
        {display_name}
      </span>
      <div className={cardStyles.buttonWrap}>
        <span className={cardStyles.shopButton}>
          Shop Brand
          <ArrowForwardRoundedIcon className={cardStyles.arrowIcon} />
        </span>
      </div>
    </div>
  )
}

export default ReOrderBrands;
